import React from 'react'
import MainLayout from '@/components/MainLayout'

const IframePage: React.FC = () => {
  return (
    <MainLayout>
      <div className="flex items-center justify-center h-full w-full p-2 sm:p-4">
        <div className="w-full sm:w-3/4 md:w-1/2 h-1/2 max-w-7xl max-h-[calc(100vh-8rem)]">
          <iframe
            src="https://crafterpromptengine.ca/"
            className="w-full h-full border border-gray-300 rounded-lg"
            title="Embedded Content"
            allowFullScreen
          />
        </div>
      </div>
    </MainLayout>
  )
}

export default IframePage

